// material-ui
import { Button } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';

import { useNavigate } from 'react-router-dom';

// project imports
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';

// project import
import { GithubOutlined } from '@ant-design/icons';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const navigate = useNavigate();

  return (
    <>
      {/* {!downLG && <Search />} */}
      {/* <Search /> */}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}
      {/* <IconButton
        component={Link}
        href="https://github.com/codedthemes/mantis-free-react-admin-template"
        target="_blank"
        disableRipple
        color="secondary"
        title="Download Free Version"
        sx={{ color: 'text.primary', bgcolor: 'grey.100' }}
      >
        <GithubOutlined />
      </IconButton> */}

      <Box sx={{ ml: 10, display: 'flex', gap: 2 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            navigate('/dashboard/default');
          }}
        >
          통합대시보드
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            navigate('/dashboard/segment');
          }}
        >
          현황판
        </Button>
      </Box>
      {/* <Notification /> */}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
